<div class="sca-method-selection">
  <ps-card class="container">
    <div class="header">
      <ps-card-title class="title">We need to verify your identity</ps-card-title>
      <button type="button" class="close" (click)="onClose()" aria-label="Close">
        <ps-icon>close</ps-icon>
      </button>
    </div>

    <ps-card-content>
      <p class="description">Please select your preferred method for receiving the verification code</p>

      <div *ngIf="scaDetails?.availableVerifications?.length" class="options">
        <button type="button" *ngFor="let verification of scaDetails.availableVerifications"
                class="option" (click)="onVerificationMethodSelection(verification)">
          <ps-icon>{{ ScaConstants.OTP_CHANNEL_ICONS[verification.channel] }}</ps-icon>
          <div class="option-text">
            <span class="option-title">{{ verification.channel }}</span>
            <span class="option-description">Verification code will be sent to {{ verification.target }}</span>
          </div>
          <ps-icon>arrow-right</ps-icon>
        </button>
      </div>
    </ps-card-content>
  </ps-card>
</div>
